import { DirectionalLight, Light, ShadowGenerator } from '@babylonjs/core/Lights';
import { Vector3 } from '@babylonjs/core/Maths';
import { Scene } from '@babylonjs/core/scene';
import { eShadowResolution } from '@models/classes/enums';
import { KbViewer } from '@view/kb-viewer';
import { ShadowManager } from '@view/render/shadow-manager';

export class XrLight extends DirectionalLight {
    constructor(public v: KbViewer, public scene: Scene) {
        super('xrLight', new Vector3(0, -3, 0), scene);

        //turn all existing lights off and save their setting
        for (const l of scene.lights) {
            if (l !== this) {
                this._originalLightEnabledMap.set(l, l.isEnabled(false));
                l.setEnabled(false);
            }
        }

        this.position = this.direction.negate();
        this.intensity = 0.5;

        this._shadowManager = new ShadowManager(this.v.bbCache);
        this._sg = this._shadowManager.add(this, eShadowResolution.low);
        this._sg.setDarkness(0.3);
        this._sg.filter = ShadowGenerator.FILTER_BLUREXPONENTIALSHADOWMAP;
        // this._sg.blurBoxOffset = 10;
        // this._sg.blurScale = 2;

        this._sg.useKernelBlur = true;
        this._sg.blurKernel = 64; //64;
        this._sg.blurScale = 2;

        /**
         * Add all meshes from the scene to the shadow caster.
         * This includes the shadow plane so that extents are auto calculated to include it
         */
        const rootNode = this.v.rendererManager.sceneRenderer.get3d(this.v.sceneNode)!;
        for (const m of rootNode.getChildMeshes(false)) {
            if (m.name == 'xrShadowPlane') {
                this._shadowManager.addReceiver(m);
            } else {
                this._shadowManager.addCaster(m);
            }
            // console.log(`adding mesh '${m.name}' to shadow generator`);
        }
    }

    private _shadowManager: ShadowManager;
    private _sg: ShadowGenerator;
    private _originalLightEnabledMap = new Map<Light, boolean>();

    public setDirection(x: number, y: number, z: number) {
        this.direction.set(x, y, z);
        this.position = this.direction.negate();
        this._shadowManager.clearProjectMatrixCache();
    }

    public dispose() {
        for (const [l, e] of this._originalLightEnabledMap) {
            l.setEnabled(e);
        }
        this._originalLightEnabledMap.clear();
        if (this._shadowManager) this._shadowManager.dispose();
        (this._shadowManager as any) = undefined;
        (this._sg as any) = undefined;

        super.dispose();
    }
}
